import fetch from "isomorphic-fetch"
import {ErrorMessages} from "../components/forms";
const defaultHeaders = {
    'Accept': '*/*',
    'Content-Type': 'application/json',
    'Cache-Control': 'no-store'
};

const flattenObject = function(ob) {
    const toReturn = {};

    for (const i in ob) {
        if (!ob.hasOwnProperty(i)) continue;

        if ((typeof ob[i]) === 'object') {
            const flatObject = flattenObject(ob[i]);
            for (const x in flatObject) {
                if (!flatObject.hasOwnProperty(x)) continue;

                toReturn[i + '.' + x] = flatObject[x];
            }
        } else {
            toReturn[i] = ob[i];
        }
    }
    return toReturn;
};


const post = (url , data) => {

    return fetch(url, {
        method: 'POST',
        mode: 'cors',
        cache: 'default',
        headers: Object.assign({} , defaultHeaders , {}),
        body: JSON.stringify(data)
    })
};

const get = (url) => {
    return fetch(url,  {
        method: 'GET',
        mode: 'cors',
        cache: 'default',
        headers: Object.assign({} , defaultHeaders , {}),

    })
};

const head = (url) => {
    return fetch(url, {
        method: 'HEAD',
        mode: 'cors',
        cache: 'default',
        headers: Object.assign({} , defaultHeaders , {}),

    });
};

const put = (url , data) => {
    return post(url,data)
};

const HTTP = {
    post ,
    get ,
    put ,
    head
};


const Errors = {

    clear : () => {
        return { type : "CLEAR_ALL_ERRORS"}
    },
    TechnicalError: (messages = []) => {
        return {
            type: "FORM_SUBMISSION_ERROR", error: {
                title: ErrorMessages.TechnicalProblemErrorMessage,
                messages: messages
            }
        };
    },
    InvalidFormSubmission: (messages = [], title = ErrorMessages.FailedFormSubmission) => {
        return {
            type: "FORM_SUBMISSION_ERROR", error: {
                title: title,
                messages: messages
            }
        };
    }
};

export {
    HTTP,
    Errors,
    flattenObject,
}

